export default __webpack_public_path__ + "static/cYN4dPcY-09f597474345b1d60ac865848c89cccc.jpg";